import React, { useState } from 'react';
import { useBlocker, useNavigate, useParams } from 'react-router-dom';
import './index.scss';
import { toast } from 'react-toastify';
import Header from '../../components/Header';
import PurchaseOrderForm from '../components/PurchaseOrderForm';
import { create_purchase_order, update_purchase_order } from '../../../services/purchaseOrder';
import { getCurrentDate } from '../../../utils/dateUtils';
import Modal from '../../../component/modal/Modal';
import Button from '../../../component/ui/Button';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../../utils/controller';

const CreatePurchaseOrder = () => {
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const [isErrortable, setIsTableError] = useState(true);
	const [disabled, setDisabled] = useState(false);
	const [isLoader, setLoader] = useState({
		isLoading: false,
		status: null,
		isSendEmail: false,
	});
	const [errorCells, setErrorCells] = useState([]);
	const [error, setError] = useState({});
	const [communicationEmail, setCommunicationEmail] = useState([]);
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isPurchaseOrderAutoSave, setIsPurchaseOrderAutoSave] = useState(false);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [formData, setFormData] = useState({
		vendor_id: '',
		purchase_order_number: '',
		date: getCurrentDate(),
		delivery_address: '',
		expected_delivery_date: '',
		delivery_method: '',
		is_draft: 1,
		purchase_order_products: [],
		email_communication: [],
		remarks: '',
	});

	function handleFormData(key, value) {
		setFormData((prev) => ({
			...prev,
			[key]: value,
		}));
	}

	async function handleCreatePurchaseOrder(body) {
		try {
			const data = await create_purchase_order(body);
			return data;
		} catch (error) {
			throw new Error(error?.message || 'Something went wrong! while creating the purchase order.');
		}
	}

	async function handleUpdatePurchaseOrder(id, body) {
		try {
			const data = await update_purchase_order(id, body);
			return data;
		} catch (error) {
			throw new Error(error?.message || 'Something went wrong! while creating the purchase order.');
		}
	}

	function checkValidation(is_draft) {
		const newError = { ...error };
		let newErrorCell = [...errorCells];
		if (!formData.vendor_id || formData.vendor_id === '' || formData.vendor_id === undefined) {
			newError.vendor_id = 'Please select a valid vendor from the list.';
		} else {
			delete newError.vendor_id;
		}
		if (
			!formData.purchase_order_number ||
			formData.purchase_order_number === '' ||
			formData.purchase_order_number === undefined
		) {
			newError.purchase_order_number = 'Please enter purchase order number in the field';
		} else {
			delete newError.purchase_order_number;
		}
		if (
			!formData.date ||
			formData.date === '' ||
			formData.date === undefined ||
			(formData.date !== '' && newError.date)
		) {
			newError.date = newError.date ?? 'Please enter date in the field';
		} else {
			delete newError.date;
		}
		// if (is_draft === 0) {
		// 	if (formData.purchase_order_products.length > 0 && errorCells.length < 1) {
		// 		let newErrorCell = [...errorCells];
		// 		const productIndex = Number(formData.purchase_order_products.length) - 1;
		// 		if (formData.purchase_order_products[productIndex].product_id === '') {
		// 			newErrorCell = [...newErrorCell, { index: productIndex, name: 'product_id' }];
		// 			newError.product_id = '';
		// 		} else {
		// 			delete newError.product_id;
		// 		}
		// 		if (formData.purchase_order_products[productIndex].product_packaging === '') {
		// 			newErrorCell = [...newErrorCell, { index: productIndex, name: 'product_packaging' }];
		// 			newError.product_packaging = '';
		// 		} else {
		// 			delete newError.product_packaging;
		// 		}
		// 		if (
		// 			formData.purchase_order_products[productIndex].order_quantity === null ||
		// 			formData.purchase_order_products[productIndex].order_quantity === '' ||
		// 			formData.purchase_order_products[productIndex].order_quantity === 0
		// 		) {
		// 			newErrorCell = [...newErrorCell, { index: productIndex, name: 'order_quantity' }];
		// 			newError.order_quantity = '';
		// 		} else {
		// 			delete newError.order_quantity;
		// 		}
		// 		setErrorCells(newErrorCell);
		// 	}
		// } else {
		// 	delete newError.product_id;
		// 	delete newError.product_packaging;
		// 	delete newError.order_quantity;
		// }

		if (is_draft === 0) {
			const products = formData.purchase_order_products || [];
			products.forEach((row, index) => {
				const isRowEmpty =
					!row.product_id &&
					!row.product_packaging &&
					(!row.order_quantity || Number(row.order_quantity) === 0);

				// First row must always validate
				if (index === 0 && isRowEmpty) {
					newErrorCell.push({ index: 0, name: 'product_id' });
					newErrorCell.push({ index: 0, name: 'product_packaging' });
					newErrorCell.push({ index: 0, name: 'order_quantity' });
				}

				// Ignore completely empty rows except first
				if (index !== 0 && isRowEmpty) {
					newErrorCell = newErrorCell.filter((err) => err.index !== index);
					console.log(newErrorCell);
				} else {
					if (!row.product_id) {
						newErrorCell.push({ index, name: 'product_id' });
					}

					if (!row.product_packaging) {
						newErrorCell.push({ index, name: 'product_packaging' });
					}

					if (!row.order_quantity || Number(row.order_quantity) === 0) {
						newErrorCell.push({ index, name: 'order_quantity' });
					}
				}
			});
		} else {
			// Draft save
			// newErrorCell.push([{}]);
			setErrorCells([]);
		}

		if ((Object.keys(newError).length > 0 || newErrorCell.length > 0) && is_draft === 0) {
			setErrorCells(newErrorCell);
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleSavePurchaseOrder = async (
		is_draft = 1,
		isSendEmail = false,
		redirectProductUrl = false,
	) => {
		let isError = checkValidation(is_draft);
		if (isError) {
			if (is_draft === 0 && isErrortable) {
				return toast.error('Error in product. Click on Show All Errors to see the description!');
			} else {
				return toast.error(
					'Something went wrong while creating purchase order! Please fill required fields.',
				);
			}
		} else {
			try {
				let purchase_order_id = null;
				setDisabled(true);
				setLoader((prev) => ({
					...prev,
					isLoading: true,
					isSendEmail: isSendEmail,
					status: is_draft,
				}));
				const body = {
					...formData,
					is_draft,
					purchase_order_products: formData?.purchase_order_products.filter(
						(product) =>
							product.product_id !== '' &&
							product.product_id !== null &&
							product.order_quantity !== 0 &&
							product.order_quantity !== null &&
							product.order_quantity !== '',
					),
				};

				if (id && !id.includes('product_id')) {
					//TODO: update purchaseOrder
					await handleUpdatePurchaseOrder(id, body);
					//TODO: set purchase_order_id for send Email
					purchase_order_id = id;
					toast.success('Purchase order updated successfully.');
				} else {
					//TODO: create purchase order
					const data = await handleCreatePurchaseOrder(body);
					//TODO: set purchase_order_id for send Email
					purchase_order_id = data?.data;
					toast.success('New Purchase Order Created Successfully.');
				}
				setDisabled(false);
				setIsLocationBlocker(false);
				setIsPurchaseOrderAutoSave(false);
				setTimeout(() => {
					navigate(`/user/${suburl}/credit-note`);
				}, 300);

				if (
					isSendEmail &&
					hasPermission(
						'purchases.purchase_orders.communications_email',
						user?.role?.role_permissions,
					)
				) {
					setTimeout(() => {
						navigate(`/user/${suburl}/purchases-order-send-emails/${purchase_order_id}`);
					}, 300);
				} else {
					if (redirectProductUrl) {
						if (hasPermission('inventory.products.create', user?.role?.role_permissions)) {
							setTimeout(() => {
								navigate(`/user/${suburl}/product-create`);
							}, 300);
						} else {
							toast.error("You don't have permission for create product in an inventory");
						}
					} else {
						setTimeout(() => {
							navigate(`/user/${suburl}/purchases-order`);
						}, 300);
					}
				}
			} catch (error) {
				setDisabled(false);
				toast.error(error?.message || 'Something went wrong!');
			} finally {
				setLoader((prev) => ({
					...prev,
					isLoading: false,
					isSendEmail: false,
					status: null,
				}));
			}
		}
	};

	useBlocker((tx) => {
		if (((id && id.includes('product_id')) || !id) && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsPurchaseOrderAutoSave(true);
			return true;
		}
		return false;
	});
	return (
		<div>
			<div className="">
				<Header
					headerTitle={
						id && !id.includes('product_id') ? 'Update Purchase Order' : 'Create New Purchase Order'
					}
					buttons={[
						{
							id: 1,
							className: 'btn-primary ',
							disabled:
								isLoader.isLoading && isLoader.status === 0 && !isLoader?.isSendEmail
									? true
									: id
										? !hasPermission('purchases.purchase_orders.edit', user?.role?.role_permissions)
										: !hasPermission(
												'purchases.purchase_orders.create',
												user?.role?.role_permissions,
											),
							button: 'Save',
							loader: isLoader.isLoading && isLoader.status === 0 && !isLoader?.isSendEmail,
							handler: () => {
								setIsPurchaseOrderAutoSave(false);
								handleSavePurchaseOrder(0, false, false);
							},
						},
						{
							id: 2,
							className: 'btn-primary',
							disabled:
								isLoader.isLoading && isLoader.status === 0 && isLoader?.isSendEmail
									? true
									: !hasPermission(
											'purchases.purchase_orders.communications_email',
											user?.role?.role_permissions,
										),
							loader: isLoader.isLoading && isLoader.status === 0 && isLoader?.isSendEmail,
							button: 'Save & Send',
							handler: () => {
								if (communicationEmail.length > 0) {
									setIsPurchaseOrderAutoSave(false);
									handleSavePurchaseOrder(0, true, false);
								} else {
									toast.error('Please add atleast one email address');
								}
							},
						},
						{
							id: 3,
							className: 'btn-primary mt-0 px-4',
							button: 'Save as Draft',
							loader: isLoader.isLoading && isLoader.status === 1,
							disabled:
								isLoader.isLoading && isLoader.status === 1
									? true
									: id
										? !hasPermission('purchases.purchase_orders.edit', user?.role?.role_permissions)
										: !hasPermission(
												'purchases.purchase_orders.create',
												user?.role?.role_permissions,
											),
							handler: () => {
								setIsPurchaseOrderAutoSave(false);
								handleSavePurchaseOrder(1, false, false);
							},
						},
					]}
					closeButton={{
						showCloseButton: true,
						handler: () => navigate(`/user/${suburl}/purchases-order`),
					}}
				/>
				<PurchaseOrderForm
					id={id}
					formData={formData}
					setFormData={setFormData}
					handleSavePurchaseOrder={handleSavePurchaseOrder}
					error={error}
					handleFormData={handleFormData}
					disabled={disabled}
					setErrorCells={setErrorCells}
					errorCells={errorCells}
					paramId={id && !id.includes('product_id') ? id : ''}
					tableError={isErrortable}
					communicationEmail={communicationEmail}
					setCommunicationEmail={setCommunicationEmail}
					setError={setError}
					setIsTableErrorShow={setIsTableError}
				/>
			</div>
			{isPurchaseOrderAutoSave && (
				<Modal
					className="deleteVendorsModal"
					title="Purchase Order Auto Save"
					isOpen={isPurchaseOrderAutoSave}
					onClose={() => {
						setIsPurchaseOrderAutoSave(false);
					}}
					cancelButton={() => {
						setIsPurchaseOrderAutoSave(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						You have unsaved changes. Do you want to continue without saving?
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Leave Without Saving"
							className="mt-0 px-4 btn-danger relative"
							onClick={() => {
								setIsLocationBlocker(false);
								setIsPurchaseOrderAutoSave(false);
								setTimeout(() => {
									navigate(isNextLocation.nextLocation?.pathname);
								}, 300);
							}}
						/>
						<Button
							type="button"
							button="Save As Draft"
							disabled={
								!hasPermission('purchases.purchase_orders.create', user?.role?.role_permissions)
							}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsPurchaseOrderAutoSave(false);
								handleSavePurchaseOrder(1);
							}}
						/>
						<Button
							type="button"
							button="Save and Continue"
							disabled={
								!hasPermission('purchases.purchase_orders.create', user?.role?.role_permissions)
							}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsPurchaseOrderAutoSave(false);
								handleSavePurchaseOrder(0);
							}}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};

export default CreatePurchaseOrder;
